import { Icon } from '@eti/components';
import { css, etiColors } from '@eti/styles';
import { rowIconWrapperStyles } from '../utils/summaryStyles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const rowStyles = css`
  align-items: center;
  background-color: ${etiColors.grayScale[2]};
  display: table-row;
  font-size: 0.875rem;
  width: 100%;

  @media (max-width: 47.9375em) {
    border-top: 1px solid ${etiColors.grayScale[8]};
    display: block;
    position: relative;
  }

  & > * {
    vertical-align: middle;

    @media (min-width: 48em) {
      border-top: 1px solid ${etiColors.grayScale[8]};
    }
  }
`;
const iconCellStyles = isAvailable => css`
  ${rowIconWrapperStyles};

  &::before {
    background-color: ${isAvailable === false ? '#e8e8e8' : etiColors.confirmation.solid};
    content: '';
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 3px;

    @media (min-width: 48em) {
      width: 4px;
    }
  }

  html[dir='rtl'] & {
    &::before {
      left: auto;
      right: 0;
    }
  }
`;
const planeIconStyles = isOutbound => css`
  fill: ${etiColors.grayScale[8]};
  height: 0.8rem;
  position: relative;
  top: 1px;
  transform: rotate(${isOutbound ? '45deg' : '225deg'});
  width: 0.8rem;

  html[dir='rtl'] & {
    transform: rotate(${isOutbound ? '225deg' : '45deg'});
  }

  @media (min-width: 48em) {
    height: 1rem;
    width: 1rem;
  }
`;
const originAndDestinationCellStyles = css`
  color: ${etiColors.black};
  display: table-cell;
  font-size: 0.75rem;

  & div {
    display: inline;

    & span {
      font-weight: 700;
    }
  }

  html[dir='rtl'] & {
    text-align: right;
  }

  @media (min-width: 48em) {
    font-size: 0.875rem;
  }
`;
const SeatMapSummarySegment = _ref => {
  let {
    destination,
    isAvailable,
    isOutbound,
    origin
  } = _ref;
  return /*#__PURE__*/_jsxs("tr", {
    className: rowStyles,
    "data-testid": "seatMapSummarySegmentRow",
    children: [/*#__PURE__*/_jsx("td", {
      className: iconCellStyles(isAvailable),
      children: /*#__PURE__*/_jsx(Icon, {
        className: planeIconStyles(isOutbound),
        id: "plane-rotated"
      })
    }), /*#__PURE__*/_jsxs("td", {
      className: originAndDestinationCellStyles,
      colSpan: 4,
      children: [/*#__PURE__*/_jsxs("div", {
        children: [origin.city, " ", /*#__PURE__*/_jsx("span", {
          children: origin.iata
        })]
      }), /*#__PURE__*/_jsx("span", {
        children: " \u2013 "
      }), /*#__PURE__*/_jsxs("div", {
        children: [destination.city, " ", /*#__PURE__*/_jsx("span", {
          children: destination.iata
        })]
      })]
    })]
  });
};
export default SeatMapSummarySegment;
//# sourceMappingURL=SummarySegmentRow.js.map